import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const InnerProductSpaceModule = () => (
  <QPhototModuleSubtopic
    title="Inner Product Space"
    videos={[
      "https://www.youtube.com/embed/Ev3Ti3Rlw7w",
      "https://www.youtube.com/embed/JRXb05znag4",
      "https://www.youtube.com/embed/ULu9cyb3obE",
      "https://www.youtube.com/embed/UOZjINOGLog"
    ]}
    takeaways={[
      
      {text:"Concentrate more on Gram-Schmidt orthogonalization."}
    ]}
    questions={[
      {image:"/cvla_94.png"},
      {image:"/cvla_95.png"},
      {image:"/cvla_96.png"},
      {image:"/cvla_97.png"},
      {image:"/cvla_98.png"},
      {image:"/cvla_99.png"},
      {image:"/cvla_100.png"},

    ]}
    exampleVideos={[]}
  />
);

export default InnerProductSpaceModule;
